import React from 'react'
import styled from 'styled-components'
import { Input } from 'antd';


const StyledWrapper = styled(Input)`
margin-top: 20px;
&.ant-input-affix-wrapper{
    border-radius: 10px !important;
}
`
const InputWrapper = (props) => {
    return(
            <StyledWrapper {...props} />
    )
}

export default InputWrapper